import {createActions, handleActions} from 'redux-actions';

export const actions = createActions({}, 'DIRTY_SET', 'DIRTY_CLEAR');

/**
 * Manage dirty state state.
 *
 * Keep track of keys that specify which items are dirty (assuming more than one thing can be dirty at a time).
 */
export const reducer = handleActions({
	[actions.dirtySet]: (state, {payload}) => ({
		...state,
		keys: {
			...state.dirtyKeys,
			[payload]: true
		}
	}),
	[actions.dirtyClear]: (state, {payload}) => ({
		...state,
		keys: Object.keys(state.keys).reduce((keys, key) => {
			if (key !== payload) { // Only keep those not included in the payload
				keys[key] = state.keys[key];
			}
			return keys;
		}, {})
	})
}, {
	keys: {}
});


// WEBPACK FOOTER //
// ./src/dirty.state.js